module.exports = __webpack_public_path__ + "static/img/model-bg39.2d12a66.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg39.jpg
// module id = uzi0
// module chunks = 0